import { render, staticRenderFns } from "./ComisionCrud.vue?vue&type=template&id=7b35f4aa"
import script from "./ComisionCrud.vue?vue&type=script&lang=js"
export * from "./ComisionCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports